import { render, staticRenderFns } from "./ActionsScreen2.vue?vue&type=template&id=5b6cf296&scoped=true&"
import script from "./ActionsScreen2.vue?vue&type=script&lang=js&"
export * from "./ActionsScreen2.vue?vue&type=script&lang=js&"
import style0 from "./ActionsScreen2.vue?vue&type=style&index=0&id=5b6cf296&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6cf296",
  null
  
)

export default component.exports